import { render, staticRenderFns } from "./RoundIconButton.vue?vue&type=template&id=9d7d4ee0"
import script from "./RoundIconButton.vue?vue&type=script&lang=js"
export * from "./RoundIconButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports